export const REDUCER_NAME = 'layout'



// WEBPACK FOOTER //
// ./src/modules/layout/state/const.js